import { makeStyles, createStyles } from '@material-ui/core/styles';

const fieldStyle = makeStyles(() =>
  createStyles({
    textField: {
      display: 'block',
      margin: '0 0 20px 0',
      '& .MuiInputBase-input': {
        background: 'transparent',
        height: '1.9rem',
        padding: '.5rem',
        border: '1px solid #d1d1d0',
        borderRadius: ' 4px',
      },
      '& .MuiInput-underline:before': { display: 'none' },
      '& .MuiInput-underline:after': { display: 'none' },
      '& .Mui-disabled': { background: '#fafafa' },
    },
    fieldLabel: {
      display: 'block',
      position: 'relative',
      color: '#1a1a1e',
      fontSize: '.9375rem',
      lineHeight: '1.4',
      margin: '0 0 .4375rem 0',
      '& + .MuiInput-formControl': {
        margin: '0',
      },
    },
    MaskInput: {
      background: 'transparent',
      height: '1.9rem',
      padding: '.5rem',
      border: '1px solid #d1d1d0',
      borderRadius: ' 4px',
      width: '100%',
      boxSizing: 'content-box',
      outline: '0',
      '&:focus': { border: '1px solid #808080' },
    },
    inpError: { color: 'red', fontSize: '12px' },
  })
);

export default fieldStyle;
